<div (contextmenu)="onRightClick($event)">
    <router-outlet ></router-outlet>
</div>


<app-footer (contextmenu)="onRightClick($event)"
    *ngIf="!(location == '/login' || location == '/register' 
    || location == 'user-dashboard')">
</app-footer>